<template>
    <div v-if="record">
        <div
            v-if="
                record.summary.givenDate && record.summary.givenDate.length > 0
            "
        >
            <strong>Given:</strong>
            {{ _setDateTimeDisplay(record.summary.givenDate) }}
        </div>
        <div v-if="record.refill > 0 && itemTypeId !== GROOMING_ID">
            <strong>Refills:</strong>
            {{
                record.summary.refills +
                " (" +
                record.summary.remainingRefill +
                " remaining)"
            }}
        </div>

        <div v-if="record.record_note && record.record_note.length > 0">
            <strong>Notes:</strong> <span v-html="record.record_note"></span>
        </div>
        <div v-if="record.diagnoses.length > 0">
            <strong>Open Diagnoses:</strong>
            <template v-if="isEditable">
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                    @click="$emit('edit-diagnosis', diagnosis)"
                    class="text-primary cursor-pointer"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
            <template v-else>
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
        </div>
        <div v-if="record.instruction && record.instruction.length > 0">
            <strong>Instructions:</strong> {{ record.instruction }}
        </div>
        <div
            v-if="
                itemTypeId == DIAGNOSTIC_IMAGING &&
                record.summary.sent_date &&
                record.summary.sent_date.length > 0
            "
        >
            <strong>Sent:</strong>
            {{ _setDateTimeDisplay(record.summary.sent_date) }}
        </div>
        <div
            v-if="
                itemTypeId == DIAGNOSTIC_IMAGING &&
                record.summary.imaging_link != null
            "
        >
            <strong>Image:</strong>
            <a :href="record.summary.imaging_link" target="_blank"
                >View Online ({{ record.summary.source_desc }})</a
            >
        </div>
        <div v-if="record.summary.attachments.length > 0">
            <strong>Attachments:</strong><br />
            <div v-for="(file, i) in record.summary.attachments" :key="file.id">
                <a v-if="file.isS3" :href="file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <a v-else :href="baseURL + file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <span v-if="i != record.summary.attachments.length - 1">,</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        record: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            GROOMING_ID: 20,
            DIAGNOSTIC_IMAGING: 17,
            baseURL: process.env.APPS
        };
    },
    computed: {
        itemTypeId() {
            return this.record && this.record.item.item_type
                ? this.record.item.item_type.id
                : 0;
        },
        isEditable() {
            return (
                this.record.business &&
                this.record.business.id === this._setting.business_id
            );
        }
    }
};
</script>
